import React from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import BackToStreamButton from '../../Duperbrowse/BackToStreamButton';
import Details from '../../DeviationViews/Details';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import PanelPopup from '../_partials/PanelPopup';
import CentralColumn from '../_partials/CentralColumn';
import DesktopLayout from '../_partials/DesktopLayout';
var DesktopStatusPage = function (_a) {
    var deviation = _a.deviation;
    return (React.createElement(DesktopLayout, { deviation: deviation, stageContent: React.createElement(React.Fragment, null,
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement(BackToStreamButton, null),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary" })), metaContent: React.createElement(CentralColumn, null,
            React.createElement(Details, { deviation: deviation }),
            React.createElement(UserGiftSaleBanner, { user: deviation.author })) }));
};
DesktopStatusPage.displayName = 'DesktopStatusPage';
export default DesktopStatusPage;
//# sourceMappingURL=DesktopStatusPage.js.map